import * as actionTypes from "./index";
import {actionCreator} from "../helpers/functions";

export const fetchWordingCategories = actionCreator(actionTypes.FETCH_WORDING_CATEGORIES);
export const fetchWordingCategoriesSuccess = actionCreator(actionTypes.FETCH_WORDING_CATEGORIES_SUCCESS);
export const fetchWordingCategoriesFailed = actionCreator(actionTypes.FETCH_WORDING_CATEGORIES_FAILED);